import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const generateData = () => {
  const data = [];
  for (let i = 0; i < 24; i++) {
    const hour = i.toString().padStart(2, '0');
    const isNightHour = i >= 22 || i < 6;
    const isPeakHour = i >= 9 && i < 17;
    
    const menCount = isNightHour ? Math.floor(Math.random() * 5) : 
                     isPeakHour ? Math.floor(Math.random() * 50) + 30 :
                     Math.floor(Math.random() * 30) + 10;
    
    const womenCount = isNightHour ? Math.floor(Math.random() * 5) : 
                       isPeakHour ? Math.floor(Math.random() * 40) + 25 :
                       Math.floor(Math.random() * 25) + 8;
    
    data.push({
      time: `${hour}:00`,
      men: menCount,
      women: womenCount
    });
  }
  return data;
};

const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const men = payload[0].value;
      const women = payload[1].value;
      const total = men + women;
      return (
        <div className="custom-tooltip bg-white border border-gray-300 p-2 rounded shadow">
          <p className="label font-bold text-black">{`Time: ${label}`}</p>
          <p className="men text-black">{`Men: ${men}`}</p>
          <p className="women text-black">{`Women: ${women}`}</p>
          <p className="total font-bold text-black">{`Total: ${total}`}</p>
        </div>
      );
    }
    return null;
  };

const InteractiveBarChart = () => {
  const data = generateData();

  return (
    <ResponsiveContainer width="100%" height={400}>
      <BarChart
        data={data}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="time" />
        <YAxis />
        <Tooltip content={<CustomTooltip />} />
        <Legend />
        <Bar dataKey="men" stackId="a" fill="#3b82f6" />
        <Bar dataKey="women" stackId="a" fill="#ec4899" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default InteractiveBarChart;